import apiList from '../constants/apiEndpoints/apiList';
import apiUrlMap from '../constants/apiEndpoints/apiUrlMap';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import set from 'lodash/set';
import * as actionTypes from '../actionTypes/translationsActionTypes';
import isArray from 'lodash/isArray';

export function saveMetaData(payload) {
  return {
    type: actionTypes.SAVE_TRANSLATIONS,
    payload: payload
  };
}

const setTranslations = (defaultTranslations, translations, dispatch, is_feature_metadata) => {
  const modifiedData = { ...translations, is_feature_metadata };
  const labelName = is_feature_metadata ? 'feature_labels' : 'screen_labels';
  Object.keys(defaultTranslations).forEach(featureName => {
    const translations = get(modifiedData, `${labelName}.${featureName}`, {});
    set(modifiedData, `${labelName}.${featureName}`, { ...defaultTranslations[featureName], ...translations });
  });
  dispatch(saveMetaData(modifiedData));
};

export const setTranslationOnLanguageChange = payload => {
  return {
    type: actionTypes.CLEAR_TRANSLATIONS,
    payload
  };
};
export const setReducerOnLanguageChange = () => {
  return {
    type: actionTypes.CLEAR_REDUCERS
  };
};

export const fetchTranslations = params => {
  return (dispatch, getState) => {
    const modifiedParams = { ...params };
    delete modifiedParams.defaultTranslations;
    const featureName = params['features'];

    // TODO review these changes again. It will break floor drop in co-oyo
    const allTranslations = get(getState(), `translationsReducer.translations.data`, {});
    const featureMetaData = allTranslations[featureName];
    const is_feature_metadata = get(params, 'is_feature_metadata');

    if (!isEmpty(featureMetaData)) {
      return;
    }

    dispatch({
      type: actionTypes.START_FETCHING_TRANSLATIONS
    });

    if (isArray(params.features)) params.features = params.features.join();

    dispatch({
      type: actionTypes.FETCHING_TRANSLATIONS,
      hmsFetchConfig: {
        queryParams: {
          features: params.features
        },
        path: is_feature_metadata ? apiUrlMap[apiList.HMS_FEATURE_METADATA_URL] :  apiUrlMap[apiList.OWNERAPP_SCREEN_METADATA]
      },
      onSuccess: ({ data }) => {
        setTranslations(params.defaultTranslations, data, dispatch, is_feature_metadata);
      },
      onError: () => {
        setTranslations(params.defaultTranslations, {}, dispatch, is_feature_metadata);
      }
    });
  };
};

export default fetchTranslations;
